import Toggle from '@/components/Toggle';

const YearlyToggle = ({ active, onChange }) => {
  return (
    <div className={'comp-yearly-toggle'}>
      <Toggle size={'xs'} active={active} onChange={onChange} />
      <p>Billed yearly?</p>
      <p className={'tag'}>-33%</p>
    </div>
  );
};

export default YearlyToggle;
